import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostPassiveAggressiveTextsFR() {
  const articleData = {
    title: 'Le Guide Ultime des Textes Passifs-Agressifs',
    description: 'Confus par des textes qui vous frustrent ou vous agacent ? Apprenez à repérer les messages passifs-agressifs avec la détection par IA de Toxic Detector.',
    slug: 'ultimate-guide-passive-aggressive-texts',
    publishDate: '2025-05-22',
    author: 'Rédaction Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: "Qu'est-ce que les textes passifs-agressifs ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Des textes qui transmettent de l'hostilité, de la critique ou de la frustration indirectement, laissant souvent le destinataire confus ou agacé."
      }
    }, {
      '@type': 'Question',
      name: 'Pourquoi les gens envoient-ils des messages passifs-agressifs ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "C'est souvent un moyen caché d'exprimer la colère, de culpabiliser ou de manipuler sans confrontation ouverte."
      }
    }, {
      '@type': 'Question',
      name: "L'IA peut-elle détecter le comportement passif-agressif dans les messages ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui. Toxic Detector analyse le ton, la formulation, l'utilisation des emojis, les modèles de réponse et le sarcasme subtil pour signaler les textes manipulateurs."
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/fr/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Le Guide Ultime des Textes Passifs-Agressifs — Comment l'IA détecte la manipulation | ToxicDetector" description="Confus par des textes qui vous frustrent ? Apprenez à repérer les messages passifs-agressifs avec l'IA." keywords="textes passifs-agressifs, comportement passif-agressif caché, modèles de manipulation de texte, détecteur d'agression passive IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/rgRp5kcuKrQdAWFQxfbcKt/file_0000000085487243beb3c848ebc5ef15.png" schema={[faqSchema, articleSchema]} data-id="element-5653" data-mp="u31wajk4h9sr" />
      <div className="flex flex-col w-full min-h-screen bg-[#fafaf9]" data-id="element-5654" data-mp="1kju5cpt75erk">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-id="element-5655" data-mp="1pb3vrsmkkm4i">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-5656" data-mp="1u9xblrpbwp7u">
            <div className="flex items-center justify-between" data-id="element-5657" data-mp="1u9drq5g4bqr6">
              <Link to="/" className="text-2xl font-bold tracking-tight" data-id="element-5658" data-mp="1ycjx7avepdwl">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Partager l'article" data-id="element-5659" data-mp="23belutg21wom">
                <Share2 size={20} data-id="element-5660" data-mp="1lmavoukvt3ah" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-12" data-id="element-5661" data-mp="1zg26056fsr79">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors" data-id="element-5662" data-mp="1ufwcskkiqwn2">
            <ArrowLeft size={16} className="mr-2" data-id="element-5663" data-mp="12nyjt12l5fb7" />
            Retour à l'Accueil
          </Link>

          <header className="mb-12" data-id="element-5664" data-mp="1gn6o28dlvdm9">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5665" data-mp="1go9debva5802">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-5666" data-mp="1bqpwf4776h4f">
              <time dateTime={articleData.publishDate} data-id="element-5667" data-mp="2s0scfrbn5b6q">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5668" data-mp="dvnc0tix9xvd">•</span>
              <span data-id="element-5669" data-mp="3w0qkmo83ks0j">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-5670" data-mp="3w2tmc5im49l3">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg" alt="IA analysant des SMS passifs-agressifs" className="w-full rounded-2xl shadow-lg" data-id="element-5671" data-mp="4te3g977sekm" />
          </div>

          <div className="bg-white rounded-2xl p-7 border border-gray-200 mb-12" data-id="element-5672" data-mp="itynf8ov8gfp">
            <h2 className="font-bold text-lg mb-5" data-id="element-5673" data-mp="irukasysjlgh">Table des Matières</h2>
            <ol className="space-y-3 text-sm list-decimal list-inside" data-id="element-5674" data-mp="nrgx51apizor">
              <li data-id="element-5675" data-mp="1bicj3hshf0o3">
                <a href="#sure-whatever" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5676" data-mp="1bhui67uvjy9u">
                  Le classique "Bien sûr, peu importe"
                </a>
              </li>
              <li data-id="element-5677" data-mp="1l6hvhfwelw0j">
                <a href="#backhanded-compliment" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5678" data-mp="1l5yogu8aks1a">
                  Le compliment ambigu
                </a>
              </li>
              <li data-id="element-5679" data-mp="1b7sqgnplw61p">
                <a href="#friendly-reminder" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5680" data-mp="1baes66ptfrc0">
                  Le "rappel amical" qui est en fait une pique
                </a>
              </li>
              <li data-id="element-5681" data-mp="xh5o8lkmzy0v">
                <a href="#ghostly-reply" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5682" data-mp="xejimrhb3sla">
                  La réponse fantôme
                </a>
              </li>
              <li data-id="element-5683" data-mp="jh4lf0ktagir">
                <a href="#sarcasm-humor" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5684" data-mp="jgmm1v2urm6m">
                  Sarcasme déguisé en humour
                </a>
              </li>
              <li data-id="element-5685" data-mp="2z7wgb8cuov25">
                <a href="#conditional-niceness" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5686" data-mp="344wllh1vlts7">
                  Gentillesse conditionnelle
                </a>
              </li>
              <li data-id="element-5687" data-mp="2bhjxh2g2hdws">
                <a href="#rollercoaster" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-5688" data-mp="2bi22angsp0gb">
                  Les montagnes russes aller-retour
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg prose-gray max-w-none" data-id="element-5689" data-mp="2q5wwk8agbcvi">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-5690" data-mp="1sq9a2v9jvj9n">
              Avez-vous déjà reçu un SMS qui vous a fait vous demander si vous
              réagissiez de manière excessive – même s'il vous a laissé agacé,
              frustré ou confus ? C'est ça, les{' '}
              <strong data-id="element-5691" data-mp="m2f2tbg5v21h">textes passifs-aggressifs</strong> en action.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-5692" data-mp="m4rrs8kc6co1">
              Notre <strong data-id="element-5693" data-mp="103hovo75occe">détection IA</strong> peut repérer ces modèles de{' '}
              <strong data-id="element-5694" data-mp="v2213odlfrqb">comportement manipulateur</strong> instantanément. Voici
              votre guide ultime.
            </p>

            <section id="sure-whatever" className="mb-12" data-id="element-5695" data-mp="19yjfypkzrohm">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5696" data-mp="1522p3nmeqw0u">
                1️⃣ Le classique "Bien sûr, peu importe"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5697" data-mp="1iusbht5um2yh">
                <p className="italic text-gray-700 text-lg" data-id="element-5698" data-mp="1ervychz2uz1x">
                  "Bien sûr, tout ce qui te rend heureux..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5699" data-mp="1nstvcgb3m6b0">
                À première vue, cela semble agréable – mais en dessous ? Rejet
                ou sarcasme. L'IA signale ces phrases.
              </p>
            </section>

            <section id="backhanded-compliment" className="mb-12" data-id="element-5700" data-mp="2caksy3hlsvw4">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5701" data-mp="1xelbi28ltjeb">
                2️⃣ Le compliment ambigu
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5702" data-mp="22gkhljvqauey">
                <p className="italic text-gray-700 text-lg" data-id="element-5703" data-mp="1olruo0diebyc">
                  "Wow, tu as vraiment fait ça... tant mieux pour toi."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5704" data-mp="1eq80bielflbp">
                Ça a l'air gentil ? Pas vraiment. Des piques cachées comme
                celles-ci sapent votre confiance.
              </p>
            </section>

            <section id="friendly-reminder" className="mb-12" data-id="element-5705" data-mp="15qbgpv729cni">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5706" data-mp="19or3bxz8cj0e">
                3️⃣ Le "rappel amical" qui est en fait une pique
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5707" data-mp="1o89tszdb686l">
                <p className="italic text-gray-700 text-lg" data-id="element-5708" data-mp="1o5x3nyxecrig">
                  "Juste pour que tu saches... j'ai nettoyé toute la cuisine."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5709" data-mp="1eadfxzszkz4s">
                Les textes passifs-agressifs masquent souvent la critique sous
                forme d'information utile.
              </p>
            </section>

            <section id="ghostly-reply" className="mb-12" data-id="element-5710" data-mp="1t7cpvubb942f">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5711" data-mp="1t748pq85nclf">
                4️⃣ La réponse fantôme
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5712" data-mp="1x6liuwyj0xwx">
                <p className="italic text-gray-700 text-lg" data-id="element-5713" data-mp="2kwpiyuciafj6">
                  "K..." ou pas de réponse du tout
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5714" data-mp="e98ebu7p5518">
                Les réponses courtes, retardées ou manquantes peuvent punir sans
                confrontation.
              </p>
            </section>

            <section id="sarcasm-humor" className="mb-12" data-id="element-5715" data-mp="nzjvwjkazcql">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5716" data-mp="j0gpovsl70h1">
                5️⃣ Sarcasme déguisé en humour
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5717" data-mp="3rhbqm5ptqash">
                <p className="italic text-gray-700 text-lg" data-id="element-5718" data-mp="3mj0f7qjvrs85">
                  "Oh, tu es tellement intelligent 😏"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5719" data-mp="as61yu6r6gz">
                Le sarcasme caché est un outil clé. Notre IA capte le contexte.
              </p>
            </section>

            <section id="conditional-niceness" className="mb-12" data-id="element-5720" data-mp="1bpnxymhuf4fh">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5721" data-mp="1bpe4uq1i4h5k">
                6️⃣ Gentillesse conditionnelle
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5722" data-mp="1nryqq57nxofr">
                <p className="italic text-gray-700 text-lg" data-id="element-5723" data-mp="1sr1tfj067ikk">
                  "J'aiderais... si je n'avais rien de prévu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5724" data-mp="1xpmlgv59qvxx">
                Les passifs-agressifs fixent des limites pour culpabiliser.
              </p>
            </section>

            <section id="rollercoaster" className="mb-12" data-id="element-5725" data-mp="1528ures5ywm9">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5726" data-mp="1a0twjin2doct">
                7️⃣ Les montagnes russes aller-retour
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-5727" data-mp="1es24sbcnr3oe">
                <p className="italic text-gray-700 text-lg" data-id="element-5728" data-mp="hb3fb0q4y6ch">
                  Hauts et bas extrêmes dans les textes
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5729" data-mp="2zl8zw0itm2ow">
                Le ton fluctuant est un signal d'alarme de comportement
                manipulateur.
              </p>
            </section>

            <section className="mb-12" data-id="element-5730" data-mp="2qkazds7lcdb2">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-5731" data-mp="2qizsvkmrgrg9">
                🛡 Comment vous protéger
              </h2>
              <ul className="space-y-4 text-lg text-gray-600" data-id="element-5732" data-mp="2lnu8iq90bkua">
                <li className="flex items-start gap-3" data-id="element-5733" data-mp="2gn6j290ffc26">
                  <span className="text-gray-900 font-bold" data-id="element-5734" data-mp="2bvwulbqm6erv">•</span>
                  <span data-id="element-5735" data-mp="2btk42a6siw37">Faites confiance à votre instinct.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-5736" data-mp="27ul5r8fkdxkq">
                  <span className="text-gray-900 font-bold" data-id="element-5737" data-mp="22vi6y5q6gnl7">•</span>
                  <span data-id="element-5738" data-mp="22t5hz8m05cyn">Gardez des captures d'écran.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-5739" data-mp="1xv3wkh13t1k0">
                  <span className="text-gray-900 font-bold" data-id="element-5740" data-mp="1swiz2pd8kvz9">•</span>
                  <span data-id="element-5741" data-mp="3sz1zg1p4p7of">Évitez de suranalyser les textes individuels.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-5742" data-mp="1sr5epijd76l">
                  <span className="text-gray-900 font-bold" data-id="element-5743" data-mp="1rfso0744p3c">•</span>
                  <span data-id="element-5744" data-mp="3j9s8wq9xnx2f">Utilisez Toxic Detector.</span>
                </li>
              </ul>
            </section>

            <section className="mb-16" data-id="element-5745" data-mp="3o7a7bmqbqtw6">
              <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-5746" data-mp="3o68t59e0hra8">
                Questions Fréquentes
              </h2>
              <div className="space-y-6" data-id="element-5747" data-mp="3f7dpo52cqvam">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-5748" data-mp="30ampvuornhkh" data-mpi={index}>
                    <h3 className="font-bold text-lg mb-3 text-gray-900" data-id="element-5749" data-mp="359prt69g97o8">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-5750" data-mp="13i49mo7g5sgg">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-gray-900 rounded-2xl p-12 text-center text-white mt-16" data-id="element-5751" data-mp="2j23m2exy1o45">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-5752" data-mp="2xq86bncna7p1">
              💀 Arrêtez de décoder. Commencez à savoir.
            </h2>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-5753" data-mp="2sxx7yoxjytyl">
              Arrêtez de deviner. Téléchargez vos textes sur Toxic Detector et
              obtenez un score de toxicité instantané.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-5754" data-mp="3gokep6vqfdjk">
              <p className="font-bold text-xl" data-id="element-5755" data-mp="3bpzhzhfovbzv">
                "🚩 65% agression passive détectée — comportement dédaigneux
                répété trouvé !"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-5756" data-mp="1hbygeosr8aw3">
              Scannez vos chats maintenant →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Votre ex est-il un narcissique caché ?',
          description: 'Découvrez si votre ex montre des signes de comportement narcissique caché dans les textes.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }, {
          title: 'Apprenez les termes : Narcissisme & Gaslighting',
          description: 'Comprenez les schémas de narcissisme et de gaslighting dans les relations.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }]} data-id="element-5757" data-mp="3mevthwh70kpm" />

          <div className="mt-12 text-center" data-id="element-5758" data-mp="rwqy8qkucie5">
            <button onClick={handleShare} className="inline-flex items-center text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-5759" data-mp="rxs6yoedwssp">
              <Share2 size={18} className="mr-2" data-id="element-5760" data-mp="x0t07la1fvc0" />
              Partager cet article
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-12 mt-16" data-id="element-5761" data-mp="s4ua9t92a59h">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-5762" data-mp="o2henxo13nqf">
            <p className="text-gray-400 text-sm" data-id="element-5763" data-mp="1kr5j1r6tnchd">
              © {new Date().getFullYear()} ToxicDetector. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </>;
}